<script setup lang="ts">
import { computed } from 'vue';
import UserAvatar from '@/components/Conversations/Avatar/UserAvatar.vue';
import {
  type ConversationMessage,
  MessageMetadataType,
} from '@/core/conversations/message/conversation-message.type';
import DateUtils from '@/utils/date-utils';

const props = defineProps<{ message: ConversationMessage }>();
const removed = computed(
  () =>
    props.message.metadata?.type === MessageMetadataType.DO_NOT_CONTACT &&
    props.message.metadata.action === 'removed',
);
const sender = computed(() => props.message.sender?.name || 'Unknown user');
</script>

<template>
  <div class="mb-3 mt-3 flex flex-row-reverse gap-1 pl-0 pr-0 font-sans" data-test="dnc-event">
    <UserAvatar :is-employer-message="true" :name="sender" vertical-position="center" />
    <div class="mr-4 min-w-0">
      <div class="mb-1 whitespace-pre-wrap text-sm text-shade-900 [overflow-wrap:anywhere]">
        {{ removed ? 'Do Not Contact removed by' : 'Marked Do Not Contact by' }}
        <span class="font-bold">{{ sender }}</span>
      </div>
      <div class="text-right text-sm text-shade-800">
        {{ DateUtils.formatTimeAndDateIfNotToday(message.createdAt) }}
      </div>
    </div>
  </div>
</template>
